import { Navigate, useLocation } from 'react-router-dom'

/**
 * Legacy URL `/profile/top-skills/:skillId`: redirects to profile (skills open via Manage skills).
 */
export function TopSkillDetailPage() {
  const location = useLocation()

  const profilePath = location.pathname.replace(/\/top-skills\/[^/]+$/, '') || '/profile'

  return <Navigate to={`${profilePath}${location.search}`} replace />
}
